export default function LockIcon({ size = 24, color = '#272937' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 10.5385V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V10.5385M8 10.5385H16M8 10.5385C6.34315 10.5385 5 11.8816 5 13.5385V16C5 18.7614 7.23858 21 10 21H14C16.7614 21 19 18.7614 19 16V13.5385C19 11.8816 17.6569 10.5385 16 10.5385M12 16.5C12.9665 16.5 13.75 15.7165 13.75 14.75C13.75 13.7835 12.9665 13 12 13C11.0335 13 10.25 13.7835 10.25 14.75C10.25 15.7165 11.0335 16.5 12 16.5ZM12 16.5V18.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
